// extracted by mini-css-extract-plugin
module.exports = {"layout":"ToggableLayout_layout__24zcc","active":"ToggableLayout_active__3zby6"};